import { http } from '@/http/axios.js'

/**
 * 校验登录
 * @param {string} mobile 手机号
 */
export function checkLoginAPI(mobile) {
  return http({
    url: '/admin/auth/login/check',
    method: 'post',
    data: {
      mobile
    }
  })
}

/**
 * 获取短信验证码
 * @param {string} mobile 手机号
 * @param {object} [captcha] 阿里云图形验证码二次校验参数（getValidate 返回值）
 *   { lot_number, captcha_output, pass_token, gen_time }
 */
export function getLoginCodeAPI(mobile, captcha) {
  return http({
    url: '/admin/auth/adminLogin/smsCode',
    method: 'post',
    data: {
      mobile,
      lot_number: captcha && captcha.lot_number,
      captcha_output: captcha && captcha.captcha_output,
      pass_token: captcha && captcha.pass_token,
      gen_time: captcha && captcha.gen_time
    }
  })
}
